import {useState, useEffect} from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

// This component checks if the user is authenticated via SSO and redirects accordingly
const PrivateLoginRoute = ({ children }) => {

    const authId = Cookies.get('authID');
    const loggedId = authId ? JSON.parse(atob(authId)) : null;
    const appEnv = process.env.REACT_APP_ENVIRONMENT;
    const ssoCheck = process.env.REACT_APP_API_SSO_PROCESS;
    const [isSSOAuthenticated, setIsSSOAuthenticated] = useState(!!loggedId?.loggedId);
   
    // Check if authID is present in session storage, if not redirect to SSO Check
    if(!isSSOAuthenticated && appEnv === 'PROD') {
        Object.keys(Cookies.get()).forEach(key => Cookies.remove(key));
        localStorage.clear();
        const baseUrl = process.env.REACT_APP_API_BASE_URL;
        const targetUrl = process.env.REACT_APP_API_SSO_CHECK_ENDPOINT;
        window.location.href = `${baseUrl}${targetUrl}`; // Redirect to SSO Check endpoint
    }

    if(appEnv === 'PFIX' && !isSSOAuthenticated && ssoCheck === 'TRUE') {
        Object.keys(Cookies.get()).forEach(key => Cookies.remove(key));
        localStorage.clear();
        return <Navigate to="/login" replace />;
    }

    // If SSO is not authenticated and the environment is not PROD, clear session and local storage and redirect to SlpMember
    if(appEnv !== 'PROD' && ssoCheck === 'TRUE' && !isSSOAuthenticated) {
        Object.keys(Cookies.get()).forEach(key => Cookies.remove(key));
        localStorage.clear();
        return <Navigate to="/SlpMember" replace />;
    }
    // If authenticated, render the children components
    return children;

}
export default PrivateLoginRoute;